import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Test from '@/pages/test.vue'
// import Currency from "@/pages/currency.vue"
import AboutWe from '@/pages/about-we.vue'
import ProductCenter from '@/pages/Product-Center.vue'
import ProjectCenter from '@/pages/Project-Center.vue'
import InformationCenter from '@/pages/Information-Center.vue'
import Informationdetails from '@/pages/Information-details.vue'
import EntrepreneurshipTraining from "@/pages/Entrepreneurship-training.vue"
import EmploymentTraining from '@/pages/EmploymentTraining.vue'
import NetworkSimulation from '@/pages/Network-simulation.vue'
import ManagementTraining from '@/pages/ManagementTraining.vue'
import LogisticsManagementPlatform from '@/pages/LogisticsManagementPlatform.vue'
import EconomicExperimentTeachingPlatform from '@/pages/EconomicExperimentTeachingPlatform.vue'
import innovationEmploymentAndEntrepreneurshipEvaluation from '@/pages/innovationEmploymentAndEntrepreneurshipEvaluation.vue'
import InternationalBusinessSimulationTeachingPlatform from '@/pages/InternationalBusinessSimulationTeachingPlatform.vue'
import NewsInformation from '@/pages/NewsInformation.vue'
import MarketingComprehensiveTrainingSystem from '@/pages/MarketingComprehensiveTrainingSystem.vue'
import DongyunQichuangLiveBroadcastPlatform from '@/pages/DongyunQichuangLiveBroadcastPlatform.vue'
import DongyunQichuangMOOCPlatform from '@/pages/DongyunQichuangMOOCPlatform.vue'


Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/AboutWe',
      name: 'AboutWe',
      component: AboutWe

    },
    {
      path: '/ProductCenter',
      name: 'ProductCenter',
      component: ProductCenter

    },
    {
      path: '/ProjectCenter',
      name: 'ProjectCenter',
      component: ProjectCenter

    },
    {
      path: '/InformationCenter',
      name: 'InformationCenter',
      component: InformationCenter
    },
    {
      path: '/Informationdetails',
      name: 'Informationdetails',
      component: Informationdetails
    },
    {//网络创业实训平台
      path: '/EntrepreneurshipTraining',
      name: 'EntrepreneurshipTraining',
      component: EntrepreneurshipTraining
    },
    {//就业实训平台
      path: '/EmploymentTraining',
      name: 'EmploymentTraining',
      component:EmploymentTraining
    },
    {//网络模拟实训平台
      path: '/NetworkSimulation',
      name: 'NetworkSimulation',
      component: NetworkSimulation
    },
    {//人力资源管理实训系统
      path: '/ManagementTraining',
      name: 'ManagementTraining',
      component: ManagementTraining
    },
    {//物流管理教学平台
      path: '/LogisticsManagementPlatform',
      name: 'LogisticsManagementPlatform',
      component: LogisticsManagementPlatform
    },
    {//经济学实验教学平台
      path: '/EconomicExperimentTeachingPlatform',
      name: 'EconomicExperimentTeachingPlatform',
      component: EconomicExperimentTeachingPlatform
    },
    {//创新就业创业测评云平台
      path: '/innovationEmploymentAndEntrepreneurshipEvaluation',
      name: 'innovationEmploymentAndEntrepreneurshipEvaluation',
      component: innovationEmploymentAndEntrepreneurshipEvaluation

    },
    { //国家商贸模拟教学平台
      path: '/InternationalBusinessSimulationTeachingPlatform',
      name: 'InternationalBusinessSimulationTeachingPlatform',
      component: InternationalBusinessSimulationTeachingPlatform
    },
    { //就业创业服务云平台
      path: '/NewsInformation',
      name: 'NewsInformation',
      component: NewsInformation
    },
    {//市场营销综合实训系统
      path: '/MarketingComprehensiveTrainingSystem',
      name: 'MarketingComprehensiveTrainingSystem',
      component: MarketingComprehensiveTrainingSystem
    },
    { //东云启创直播平台
      path: '/DongyunQichuangLiveBroadcastPlatform',
      name : 'DongyunQichuangLiveBroadcastPlatform',
      component: DongyunQichuangLiveBroadcastPlatform
    },
    {
      path: '/DongyunQichuangMOOCPlatform',
      name : 'DongyunQichuangMOOCPlatform',
      component :DongyunQichuangMOOCPlatform
    },

    // {
    //   path:'/Currency',
    //   name: 'Currency',
    //   component: Currency,
    //   children:[

    //   ]
    // },

    // {
    //   path: '/footer',
    //   name: 'footer',
    //   component: Index,
    // },
    // {
    //   path: '/header',
    //   name: 'header',
    //   component: Index,
    //   children:[
    //     {

    //     }
    //   ]
    // },
    {
      path: '/test',
      name: 'test',
      component: Test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js